import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    actions: {
        padding: theme.spacing(1, 2),

        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(1, 0.5),
        },
    },
    comment: {
        margin: theme.spacing(0.5, 0),
        flexBasis: '100%',
    },
    content: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'flex-start',
        minWidth: 300,
        padding: theme.spacing(0, 2),

        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(0, 1),
        },
    },
    date: {
        margin: theme.spacing(0.5, 0),
        flexBasis: '66%',
    },
    dates: {
        display: 'flex',
        margin: theme.spacing(1, 0),
        flex: '1 0 100%',

        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column',
        },
    },
    input: {
        height: '1.4em',
    },
    formControl: {
        margin: theme.spacing(0.5, 0),
        flexBasis: '100%',
    },
    picker: {
        flexGrow: 1,
    },
    textarea: {
        '& .MuiInput-root': {
            height: 'auto',
        },
    },
    title: {
        padding: theme.spacing(2, 2, 1),

        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(2, 1, 1),
        },
    },
}));

export { useStyles };
